export enum BOOK_KIT_ROUTES {
  HOME = 'home',
  DISCOVERY = 'discovery',
  ABOUT = 'about',
  CONTACT = 'contact',
  SEARCH = 'search',
  DETAILS = 'details',
  RESERVATION = 'reservation',
  EXTRAS = 'extras',
  VENDORS = 'vendors',
  CHECKOUT = 'checkout',
  SUCCESS = 'success',
  FAILURE = 'failure',
  FINALIZE = 'finalize',
  RESERVATIONS = 'reservations',
  PAYMENTS = 'payments',
  TRIPS = 'trips',
}
